import { useCallback } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { PanelId } from '../dashboard/registry'
import { usePersistedState } from './localStore'
import { attributionStamp } from './attribution'
import { currentCoachName } from './currentCoachName'

const STORAGE_KEY = 'advanced.componentTickets.v1'

export type ComponentTicket = {
  id: string
  panelId: PanelId
  text: string
  submittedBy: string
  submittedAt: string
}

export type ComponentTicketsState = {
  tickets: ComponentTicket[]
  submit: (panelId: PanelId, text: string) => void
  ticketsFor: (panelId: PanelId) => ComponentTicket[]
}

const makeTicketId = (panelId: PanelId) => `${panelId}-${uuidv4()}`

export const useComponentTickets = (): ComponentTicketsState => {
  const [tickets, setTickets] = usePersistedState<ComponentTicket[]>(STORAGE_KEY, [])

  const submit = useCallback(
    (panelId: PanelId, text: string) => {
      setTickets((current) => [
        ...current,
        {
          id: makeTicketId(panelId),
          panelId,
          text,
          ...attributionStamp(),
        },
      ])
    },
    [setTickets]
  )

  const ticketsFor = useCallback(
    (panelId: PanelId) => {
      const me = currentCoachName()

      return tickets.filter((ticket) => ticket.panelId === panelId && ticket.submittedBy === me)
    },
    [tickets]
  )

  return { tickets, submit, ticketsFor }
}
